import request from '../request'
import qs from 'query-string'



// 获取所有产品类目
export function getProductCategoryListApi() {
    return request.get('/api/products/category')
}

//分页获取产品类目
export function getProductCategoryListByPageApi(params: any) {
    return request.get('/api/products/category/page', { params })
}

// 新增产品类目
export function addProductCategoryApi(params: any) {
    return request.post('/api/products/category', params)
}

//根据ID获取产品类目
export function getProductCategoryByIdApi(id: string) {
    return request.get(`/api/products/category/${id}`)
}

//根据ID更新产品类目
export function updateProductCategoryByIdApi(id: string, params: any) {
    return request.put(`/api/products/category/${id}`, params)
}

//根据ID删除产品类目
export function deleteProductCategoryByIdApi(id: string) {
    return request.delete(`/api/products/category/${id}`)
}

//批量删除产品类目
export function deleteProductCategoryBatchApi(params: any) {
    return request.post(`/api/products/category/batch_delete`, params)
}






// 分页获取产品
export function getProductListByPageApi(params: any) {
    return request.post('/api/products/page', params)
}


// 根据id获取产品
export function getProductByIdApi(id: string) {
    return request.get(`/api/products/${id}`)
}

//新增产品
export function addProductApi(params: any) {
    return request.post('/api/products', params)
}

//根据id更新产品
export function updateProductByIdApi(id: string, params: any) {
    return request.put(`/api/products/${id}`, params)
}

//根据id删除产品
export function deleteProductByIdApi(id: string) {
    return request.delete(`/api/products/${id}`)
}

//批量删除产品
export function deleteProductBatchApi(params: any) {
    return request.post(`/api/products/batch_delete`, params)
}

//上下架商品
export function shelfProductApi(params: any) {
    return request.post(`/api/products/shelf`, params)
}



//获取推荐商品
export function getRecommendProductApi(params: any) {
    return request.get(`/api/recommends/products`, { params })
}

//关联推荐商品
export function bindRecommendProductApi(params: any) {
    return request.post(`/api/recommends/bind`, params)
}

//批量移除
export function batchRemoveRecommendProductApi(params: any) {
    return request.post(`/api/recommends/unbind`, params)
}


//导入
export function importGoods(params: any) {
    return request.post(`/api/excel/goods`, params, { headers: { 'Content-Type': 'multipart/form-data' } })
}

